export const SourceConfigEnum = {
	ACCESS_MASTER: 'access-master',
	FUNCTIONALITY_CONFIGURATION: 'functionality-configuration'
};
